import {call, put, takeEvery} from 'redux-saga/effects' 
import { isValidateToken } from '../utils/utils';
import {
    FETCH_RESOURCE_LOADED,
    FETCH_RESOURCE_ERROR,
} from '../actions/auxiliar_actions'

import {
    FETCH_GET_USER_DATA,
    FETCH_GET_USER_DATA_SUCCESS,
    FETCH_GET_USER_LIST,
    FETCH_GET_USER_LIST_SUCCESS,
    FETCH_ADD_USER,
    FETCH_ADD_USER_SUCCESS,
    FETCH_REMOVE_USER,
    FETCH_REMOVE_USER_SUCCESS,
    FETCH_GET_MODELS_BY_USER,
    FETCH_GET_MODELS_BY_USER_SUCCESS,
    FETCH_GET_NEW_API_TOKEN,
    FETCH_GET_NEW_API_TOKEN_SUCCESS,
    FETCH_DELETE_API_TOKEN,
    FETCH_DELETE_API_TOKEN_SUCCESS,
    FETCH_SET_DARKMODE,
    FETCH_SET_DARKMODE_SUCCESS,
    FETCH_GET_VALIDATION_USERID,
    FETCH_GET_VALIDATION_USERID_SUCCESS,
    FETCH_CHANGE_USERID,
    FETCH_CHANGE_USERID_SUCCESS,
    FETCH_CHANGE_PASSWORD,
    FETCH_CHANGE_PASSWORD_SUCCESS,
    FETCH_NEW_PASSWORD,
    FETCH_NEW_PASSWORD_SUCCESS
} from '../actions/user_actions';
import {
    FETCH_RENEW_PASSWORD_SUCCESS,
    // FETCH_GET_MODELS_SUCCESS,
} from '../actions/auth_actions';
import {
    FETCH_ADD_MODEL,
    FETCH_ADD_MODEL_SUCCESS,
    FETCH_EDIT_MODEL,
    FETCH_EDIT_MODEL_SUCCESS,
    FETCH_DELETE_MODEL,
    FETCH_DELETE_MODEL_SUCCESS,
    FETCH_VERSION_MODEL,
    FETCH_VERSION_MODEL_SUCCESS
} from '../actions/model_actions';
import { 
    getUserData, 
    getUserList, 
    addUser, 
    removeUser, 
    getModelsByUser, 
    addModel, 
    editModel, 
    deleteModel, 
    versionManage, 
    getNewApiToken,
    deleteApiToken,
    setDarkMode,
    getValidationUserId,
    changeUserId,
    postForgotPassword,
    postNewPassword
} from '../services/user_service';
import { refreshToken } from '../services/auth_services';

function* fetchGetUserDataSaga({payload}){
    // console.log(payload)
    try {
        const userResponse = yield call(getUserData, payload.params.token);
        let data = userResponse.data
        if(userResponse.status === 200){
            yield put({type: FETCH_GET_USER_DATA_SUCCESS, payload: userResponse.data})
            yield put({type: FETCH_RESOURCE_LOADED})
        } else {
            yield put({type: FETCH_RESOURCE_ERROR, payload: data})
        }
    } catch(error){
        yield put({type: FETCH_RESOURCE_ERROR, payload: error})
    }
}

function* fetchGetUserListSaga({payload}){
    // console.log(payload)
    try {
        const userListResponse = yield call(getUserList, payload.params.token);
        let data = userListResponse.data
        console.log(userListResponse)
        if(userListResponse.status === 200){
            yield put({type: FETCH_GET_USER_LIST_SUCCESS, payload: userListResponse.data})
            yield put({type: FETCH_RESOURCE_LOADED})
        } else {
            let renewToken = document.cookie.replace(/(?:(?:^|.*;\s*)refreshToken\s*\=\s*([^;]*).*$)|^.*$/, "$1");

            if(data && data.detail && isValidateToken(data.detail)) {
                const refreshResponse = yield call(refreshToken, renewToken);
                // console.log("Refresh: ", refreshResponse)
                if(refreshResponse.status === 200){
                    document.cookie = `idToken=${refreshResponse.data.idToken}; max-age=${60*60*3}; path=/`
                    document.cookie = `refreshToken=${refreshResponse.data.refreshToken}; max-age=${60*60*3}; path=/`
                    refreshResponse.data.action = "New Token"
                    yield put({type: FETCH_RENEW_PASSWORD_SUCCESS, payload: refreshResponse.data})
                    yield put({type: FETCH_RESOURCE_LOADED})
                } else {
                    yield put({type: FETCH_RESOURCE_ERROR, payload: refreshResponse.data})
                }
            } else yield put({type: FETCH_RESOURCE_ERROR, payload: data});
        }
    } catch(error){
        yield put({type: FETCH_RESOURCE_ERROR, payload: error})
    }
}

function* fetchAddUserSaga({payload}){
    // console.log(payload)
    try {
        const addUserResponse = yield call(addUser, payload.params.token, payload.params.email, payload.params.organization, payload.params.is_admin, payload.params.user_id);
        let data = addUserResponse.data
        console.log(addUserResponse)
        if(addUserResponse.status === 200){
            yield put({type: FETCH_ADD_USER_SUCCESS, payload: addUserResponse.data})
            const userListResponse = yield call(getUserList, payload.params.token);
            let data = userListResponse.data
            if(userListResponse.status === 200){
                yield put({type: FETCH_GET_USER_LIST_SUCCESS, payload: data})
                yield put({type: FETCH_RESOURCE_LOADED})
            }
            yield put({type: FETCH_RESOURCE_LOADED})
        } else {
            let renewToken = document.cookie.replace(/(?:(?:^|.*;\s*)refreshToken\s*\=\s*([^;]*).*$)|^.*$/, "$1");

            if(data && data.detail && isValidateToken(data.detail)) {
                const refreshResponse = yield call(refreshToken, renewToken);
                // console.log("Refresh: ", refreshResponse)
                if(refreshResponse.status === 200) {
                    document.cookie = `idToken=${refreshResponse.data.idToken}; max-age=${60*60*3}; path=/`
                    document.cookie = `refreshToken=${refreshResponse.data.refreshToken}; max-age=${60*60*3}; path=/`
                    refreshResponse.data.action = "New Token"
                    yield put({type: FETCH_RENEW_PASSWORD_SUCCESS, payload: refreshResponse.data})
                    const addUserResponse2 = yield call(addUser, refreshResponse.data.idToken, payload.params.email, payload.params.organization, payload.params.is_admin);
                    let data2 = addUserResponse2.data
                    if(addUserResponse2.status === 200){
                        yield put({type: FETCH_ADD_USER_SUCCESS, payload: data2})
                        const userListResponse2 = yield call(getUserList, refreshResponse.data.idToken);
                        let data = userListResponse2.data
                        if(userListResponse2.status === 200){
                            yield put({type: FETCH_GET_USER_LIST_SUCCESS, payload: data})
                            yield put({type: FETCH_RESOURCE_LOADED})
                        }
                        yield put({type: FETCH_RESOURCE_LOADED})
                    }
                    yield put({type: FETCH_RESOURCE_LOADED})
                } else {
                    yield put({type: FETCH_RESOURCE_ERROR, payload: refreshResponse.data})
                }
            } else yield put({type: FETCH_RESOURCE_ERROR, payload: data});
        }
    } catch(error){
        yield put({type: FETCH_RESOURCE_ERROR, payload: error})
    }
}

function* fetchRemoveUserSaga({payload}){
    console.log(payload)
    try {
        const removeUserResponse = yield call(removeUser, payload.params.token, payload.params.user_id);
        let data = removeUserResponse.data
        // console.log('Remove user response',removeUserResponse)
        if(removeUserResponse.status === 200){
            yield put({type: FETCH_REMOVE_USER_SUCCESS, payload: removeUserResponse.data})
            yield put({type: FETCH_RESOURCE_LOADED})
            const userListResponse = yield call(getUserList, payload.params.token);
            let data = userListResponse.data
            if(userListResponse.status === 200){
                yield put({type: FETCH_GET_USER_LIST_SUCCESS, payload: data})
                yield put({type: FETCH_RESOURCE_LOADED})
            }
        } else {
            let renewToken = document.cookie.replace(/(?:(?:^|.*;\s*)refreshToken\s*\=\s*([^;]*).*$)|^.*$/, "$1");

            if(data && data.detail && isValidateToken(data.detail)) {
                const refreshResponse = yield call(refreshToken, renewToken);
                // console.log("Refresh: ", refreshResponse)
                if(refreshResponse.status === 200) {
                    document.cookie = `idToken=${refreshResponse.data.idToken}; max-age=${60*60*3}; path=/`
                    document.cookie = `refreshToken=${refreshResponse.data.refreshToken}; max-age=${60*60*3}; path=/`
                    refreshResponse.data.action = "New Token"
                    yield put({type: FETCH_RENEW_PASSWORD_SUCCESS, payload: refreshResponse.data})
                    const removeUserResponse2 = yield call(removeUser, refreshResponse.data.idToken, payload.params.email);
                    let data = removeUserResponse2.data
                    // console.log('Remove user response',removeUserResponse)
                    if(removeUserResponse2.status === 200){
                        yield put({type: FETCH_REMOVE_USER_SUCCESS, payload: removeUserResponse2.data})
                        yield put({type: FETCH_RESOURCE_LOADED})
                        const userListResponse2 = yield call(getUserList, refreshResponse.data.idToken);
                        let data = userListResponse2.data
                        if(userListResponse2.status === 200){
                            yield put({type: FETCH_GET_USER_LIST_SUCCESS, payload: data})
                            yield put({type: FETCH_RESOURCE_LOADED})
                        }
                    }
                    yield put({type: FETCH_RESOURCE_LOADED})
                } else {
                    yield put({type: FETCH_RESOURCE_ERROR, payload: refreshResponse.data})
                }
            } else yield put({type: FETCH_RESOURCE_ERROR, payload: data});
        }
    } catch(error){
        yield put({type: FETCH_RESOURCE_ERROR, payload: error})
    }
}

function* fetchGetModelsByUserSaga({payload}){
    // console.log(payload)
    try {
        const userModelsResponse = yield call(getModelsByUser, payload.params.token, payload.params.query_user);
        let data = userModelsResponse.data
        console.log(userModelsResponse)
        if(userModelsResponse.status === 200){
            yield put({type: FETCH_GET_MODELS_BY_USER_SUCCESS, payload: userModelsResponse.data})
            yield put({type: FETCH_RESOURCE_LOADED})
        } else {
            let renewToken = document.cookie.replace(/(?:(?:^|.*;\s*)refreshToken\s*\=\s*([^;]*).*$)|^.*$/, "$1");

            if(data && data.detail && isValidateToken(data.detail)) {
                const refreshResponse = yield call(refreshToken, renewToken);
                // console.log("Refresh: ", refreshResponse)
                if(refreshResponse.status === 200){
                    document.cookie = `idToken=${refreshResponse.data.idToken}; max-age=${60*60*3}; path=/`
                    document.cookie = `refreshToken=${refreshResponse.data.refreshToken}; max-age=${60*60*3}; path=/`
                    refreshResponse.data.action = "New Token"
                    yield put({type: FETCH_RENEW_PASSWORD_SUCCESS, payload: refreshResponse.data})
                    yield put({type: FETCH_RESOURCE_LOADED})
                } else {
                    yield put({type: FETCH_RESOURCE_ERROR, payload: refreshResponse.data})
                }
            } else yield put({type: FETCH_RESOURCE_ERROR, payload: data});
        }
    } catch(error){
        yield put({type: FETCH_RESOURCE_ERROR, payload: error})
    }
}

function* fetchAddModelSaga({payload}){
    // console.log(payload)
    try {
        const addModelResponse = yield call(addModel, 
            payload.params.token, 
            payload.params.client_id, 
            payload.params.model_id, 
            payload.params.model_name, 
            payload.params.description, 
            payload.params.model_type, 
            // payload.params.routing_table, 
            payload.params.model_url);
        let data = addModelResponse.data
        console.log("Add Model Response: ", addModelResponse);
        if(addModelResponse.status === 200){
            yield put({type: FETCH_ADD_MODEL_SUCCESS, payload: data})
            yield put({type: FETCH_RESOURCE_LOADED})
            const userModelsResponse = yield call(getModelsByUser, payload.params.token, payload.params.client_id);
            // let data = userModelsResponse.data
            // console.log(userModelsResponse);
            if(userModelsResponse.status === 200){
                yield put({type: FETCH_GET_MODELS_BY_USER_SUCCESS, payload: userModelsResponse.data})
                yield put({type: FETCH_RESOURCE_LOADED})
            }
        } else {
            let renewToken = document.cookie.replace(/(?:(?:^|.*;\s*)refreshToken\s*\=\s*([^;]*).*$)|^.*$/, "$1");

            if(data && data.detail && isValidateToken(data.detail)) {
                const refreshResponse = yield call(refreshToken, renewToken);
                // console.log("Refresh: ", refreshResponse)
                if(refreshResponse.status === 200) {
                    document.cookie = `idToken=${refreshResponse.data.idToken}; max-age=${60*60*3}; path=/`
                    document.cookie = `refreshToken=${refreshResponse.data.refreshToken}; max-age=${60*60*3}; path=/`
                    refreshResponse.data.action = "New Token"
                    yield put({type: FETCH_RENEW_PASSWORD_SUCCESS, payload: refreshResponse.data})
                    const addModelResponse2 = yield call(addModel, refreshResponse.data.idToken, payload.params.client_id, payload.params.model_id, payload.params.model_name, payload.params.description, payload.params.model_type);
                    let data = addModelResponse2.data
                    // console.log(addModelResponse2);
                    if(addModelResponse2.status === 200){
                        yield put({type: FETCH_ADD_MODEL_SUCCESS, payload: data})
                        yield put({type: FETCH_RESOURCE_LOADED})
                        const userModelsResponse2 = yield call(getModelsByUser, refreshResponse.data.idToken, payload.params.client_id);
                        // let data = userModelsResponse.data
                        // console.log(userModelsResponse);
                        if(userModelsResponse2.status === 200){
                            yield put({type: FETCH_GET_MODELS_BY_USER_SUCCESS, payload: userModelsResponse2.data})
                            yield put({type: FETCH_RESOURCE_LOADED})
                        }
                    }
                    yield put({type: FETCH_RESOURCE_LOADED})
                } else {
                    yield put({type: FETCH_RESOURCE_ERROR, payload: refreshResponse.data})
                }
            } else yield put({type: FETCH_RESOURCE_ERROR, payload: data});
        }
    } catch(error){
        yield put({type: FETCH_RESOURCE_ERROR, payload: error})
    }
}

function* fetchEditModelSaga({payload}){
    console.log(payload)
    try {
        const editModelResponse = yield call(
            editModel, 
            payload.params.token, 
            payload.params.client_id, 
            payload.params.model_id, 
            payload.params.model_name, 
            payload.params.description, 
            payload.params.model_type,
            payload.params.extra_info,
            payload.params.plot_conf,
            payload.params.background_image,
            payload.params.routing_table, 
            payload.params.model_url
        );
        let data = editModelResponse.data
        console.log(editModelResponse);
        if(editModelResponse.status === 200){
            yield put({type: FETCH_EDIT_MODEL_SUCCESS, payload: data})
            yield put({type: FETCH_RESOURCE_LOADED})
            const userModelsResponse = yield call(getModelsByUser, payload.params.token, payload.params.client_id);
            // let data = userModelsResponse.data
            // console.log(userModelsResponse);
            if(userModelsResponse.status === 200){
                yield put({type: FETCH_GET_MODELS_BY_USER_SUCCESS, payload: userModelsResponse.data})
                yield put({type: FETCH_RESOURCE_LOADED})
            }
        } else {
            let renewToken = document.cookie.replace(/(?:(?:^|.*;\s*)refreshToken\s*\=\s*([^;]*).*$)|^.*$/, "$1");

            if(data && data.detail && isValidateToken(data.detail)) {
                const refreshResponse = yield call(refreshToken, renewToken);
                // console.log("Refresh: ", refreshResponse)
                if(refreshResponse.status === 200) {
                    document.cookie = `idToken=${refreshResponse.data.idToken}; max-age=${60*60*3}; path=/`
                    document.cookie = `refreshToken=${refreshResponse.data.refreshToken}; max-age=${60*60*3}; path=/`
                    refreshResponse.data.action = "New Token"
                    yield put({type: FETCH_RENEW_PASSWORD_SUCCESS, payload: refreshResponse.data})
                    const editModelResponse2 = yield call(
                        editModel, 
                        refreshResponse.data.idToken, 
                        payload.params.client_id, 
                        payload.params.model_id, 
                        payload.params.model_name, 
                        payload.params.description, 
                        payload.params.model_type,
                        payload.params.extra_info,
                        payload.params.plot_conf,
                        payload.params.background_image
                    );
                    let data = editModelResponse2.data
                    console.log(editModelResponse2);
                    if(editModelResponse2.status === 200){
                        yield put({type: FETCH_EDIT_MODEL_SUCCESS, payload: data})
                        yield put({type: FETCH_RESOURCE_LOADED})
                        const userModelsResponse2 = yield call(getModelsByUser, refreshResponse.data.idToken, payload.params.client_id);
                        // let data = userModelsResponse.data
                        // console.log(userModelsResponse);
                        if(userModelsResponse2.status === 200){
                            yield put({type: FETCH_GET_MODELS_BY_USER_SUCCESS, payload: userModelsResponse2.data})
                            yield put({type: FETCH_RESOURCE_LOADED})
                        }
                    }
                    yield put({type: FETCH_RESOURCE_LOADED})
                } else {
                    yield put({type: FETCH_RESOURCE_ERROR, payload: refreshResponse.data})
                }
            } else yield put({type: FETCH_RESOURCE_ERROR, payload: data});
        }
    } catch(error){
        yield put({type: FETCH_RESOURCE_ERROR, payload: error})
    }
}

function* fetchDeleteModelSaga({payload}){
    // console.log(payload)
    try {
        const deleteModelResponse = yield call(deleteModel, payload.params.token, payload.params.client_id, payload.params.model_id);
        let data = deleteModelResponse.data
        console.log(deleteModelResponse);
        if(deleteModelResponse.status === 200){
            yield put({type: FETCH_DELETE_MODEL_SUCCESS, payload: data})
            yield put({type: FETCH_RESOURCE_LOADED})
            const userModelsResponse = yield call(getModelsByUser, payload.params.token, payload.params.client_id);
            // let data = userModelsResponse.data
            // console.log(userModelsResponse);
            if(userModelsResponse.status === 200){
                yield put({type: FETCH_GET_MODELS_BY_USER_SUCCESS, payload: userModelsResponse.data})
                yield put({type: FETCH_RESOURCE_LOADED})
            }
        } else {
            let renewToken = document.cookie.replace(/(?:(?:^|.*;\s*)refreshToken\s*\=\s*([^;]*).*$)|^.*$/, "$1");

            if(data && data.detail && isValidateToken(data.detail)) {
                const refreshResponse = yield call(refreshToken, renewToken);
                // console.log("Refresh: ", refreshResponse)
                if(refreshResponse.status === 200) {
                    document.cookie = `idToken=${refreshResponse.data.idToken}; max-age=${60*60*3}; path=/`
                    document.cookie = `refreshToken=${refreshResponse.data.refreshToken}; max-age=${60*60*3}; path=/`
                    refreshResponse.data.action = "New Token"
                    yield put({type: FETCH_RENEW_PASSWORD_SUCCESS, payload: refreshResponse.data})
                    const deleteModelResponse2 = yield call(deleteModel, refreshResponse.data.idToken, payload.params.client_id, payload.params.model_id);
                    let data = deleteModelResponse2.data
                    console.log(deleteModelResponse2);
                    if(deleteModelResponse2.status === 200){
                        yield put({type: FETCH_DELETE_MODEL_SUCCESS, payload: data})
                        yield put({type: FETCH_RESOURCE_LOADED})
                        const userModelsResponse2 = yield call(getModelsByUser, refreshResponse.data.idToken, payload.params.client_id);
                        // let data = userModelsResponse.data
                        // console.log(userModelsResponse);
                        if(userModelsResponse2.status === 200){
                            yield put({type: FETCH_GET_MODELS_BY_USER_SUCCESS, payload: userModelsResponse2.data})
                            yield put({type: FETCH_RESOURCE_LOADED})
                        }
                    }
                    yield put({type: FETCH_RESOURCE_LOADED})
                } else {
                    yield put({type: FETCH_RESOURCE_ERROR, payload: refreshResponse.data})
                }
            } else yield put({type: FETCH_RESOURCE_ERROR, payload: data});
        }
    } catch(error){
        yield put({type: FETCH_RESOURCE_ERROR, payload: error})
    }
}

function* fetchVersionOperationSaga({payload}){
    // console.log(payload)
    try {
        const versionModelResponse = yield call(versionManage, payload.params.token, payload.params.client_id, payload.params.model_id, payload.params.operation, payload.params.pop_version_name, payload.params.new_version);
        let data = versionModelResponse.data
        console.log(versionModelResponse);
        if(versionModelResponse.status === 200){
            data.operation = payload.params.operation
            yield put({type: FETCH_VERSION_MODEL_SUCCESS, payload: data})
            yield put({type: FETCH_RESOURCE_LOADED})
            const userModelsResponse = yield call(getModelsByUser, payload.params.token, payload.params.client_id);
            // let data = userModelsResponse.data
            // console.log(userModelsResponse);
            if(userModelsResponse.status === 200){
                yield put({type: FETCH_GET_MODELS_BY_USER_SUCCESS, payload: userModelsResponse.data})
                yield put({type: FETCH_RESOURCE_LOADED})
            }
        } else {
            let renewToken = document.cookie.replace(/(?:(?:^|.*;\s*)refreshToken\s*\=\s*([^;]*).*$)|^.*$/, "$1");

            if(data && data.detail && isValidateToken(data.detail)) {
                const refreshResponse = yield call(refreshToken, renewToken);
                // console.log("Refresh: ", refreshResponse)
                if(refreshResponse.status === 200) {
                    document.cookie = `idToken=${refreshResponse.data.idToken}; max-age=${60*60*3}; path=/`
                    document.cookie = `refreshToken=${refreshResponse.data.refreshToken}; max-age=${60*60*3}; path=/`
                    refreshResponse.data.action = "New Token"
                    yield put({type: FETCH_RENEW_PASSWORD_SUCCESS, payload: refreshResponse.data})
                    const versionModelResponse2 = yield call(versionManage, refreshResponse.data.idToken, payload.params.client_id, payload.params.model_id, payload.params.operation, payload.params.pop_version_name, payload.params.new_version);
                    let data = versionModelResponse2.data
                    console.log(versionModelResponse2);
                    if(versionModelResponse2.status === 200){
                        data.operation = payload.params.operation
                        yield put({type: FETCH_VERSION_MODEL_SUCCESS, payload: data})
                        yield put({type: FETCH_RESOURCE_LOADED})
                        const userModelsResponse = yield call(getModelsByUser, refreshResponse.data.idToken, payload.params.client_id);
                        // let data = userModelsResponse.data
                        // console.log(userModelsResponse);
                        if(userModelsResponse.status === 200){
                            yield put({type: FETCH_GET_MODELS_BY_USER_SUCCESS, payload: userModelsResponse.data})
                            yield put({type: FETCH_RESOURCE_LOADED})
                        }
                    }
                    yield put({type: FETCH_RESOURCE_LOADED})
                } else {
                    yield put({type: FETCH_RESOURCE_ERROR, payload: refreshResponse.data})
                }
            } else yield put({type: FETCH_RESOURCE_ERROR, payload: data});
        }
    } catch(error){
        yield put({type: FETCH_RESOURCE_ERROR, payload: error})
    }
}

function* fetchGetApiTokenSaga({payload}){
    console.log(payload)
    try {
        const apiTokenResponse = yield call(getNewApiToken, payload.params.token);
        console.log('Create: ', apiTokenResponse);
        let data = apiTokenResponse ? apiTokenResponse.data : null
        if(apiTokenResponse && apiTokenResponse.status === 200){
            yield put({type: FETCH_GET_NEW_API_TOKEN_SUCCESS, payload: data})
            yield put({type: FETCH_RESOURCE_LOADED})
            // console.log(userModelsResponse);
            const userResponse = yield call(getUserData, payload.params.token);
            if(userResponse.status === 200){
                yield put({type: FETCH_GET_USER_DATA_SUCCESS, payload: userResponse.data})
                yield put({type: FETCH_RESOURCE_LOADED})
            }
        } else {
            console.log(apiTokenResponse)
            let renewToken = document.cookie.replace(/(?:(?:^|.*;\s*)refreshToken\s*\=\s*([^;]*).*$)|^.*$/, "$1");

            if(data && data.detail && isValidateToken(data.detail)) {
                const refreshResponse = yield call(refreshToken, renewToken);
                // console.log("Refresh: ", refreshResponse)
                if(refreshResponse.status === 200) {
                    document.cookie = `idToken=${refreshResponse.data.idToken}; max-age=${60*60*3}; path=/`
                    document.cookie = `refreshToken=${refreshResponse.data.refreshToken}; max-age=${60*60*3}; path=/`
                    refreshResponse.data.action = "New Token"
                    yield put({type: FETCH_RENEW_PASSWORD_SUCCESS, payload: refreshResponse.data})
                    
                    const apiTokenResponse2 = yield call(getNewApiToken, payload.params.token);
                    let data2 = apiTokenResponse2.data
                    console.log(apiTokenResponse2);
                    if(apiTokenResponse2.status === 200){
                        yield put({type: FETCH_GET_NEW_API_TOKEN_SUCCESS, payload: data2})
                        yield put({type: FETCH_RESOURCE_LOADED})
                        // console.log(apiTokenResponse2);
                        const userResponse2 = yield call(getUserData, refreshResponse.data.idToken);
                        if(userResponse2.status === 200){
                            yield put({type: FETCH_GET_USER_DATA_SUCCESS, payload: userResponse2.data})
                            yield put({type: FETCH_RESOURCE_LOADED})
                        }
                    }
                    yield put({type: FETCH_RESOURCE_LOADED})
                } else {
                    yield put({type: FETCH_RESOURCE_ERROR, payload: refreshResponse.data})
                }
            } else yield put({type: FETCH_RESOURCE_ERROR, payload: data});
        }
    } catch(error){
        console.log(error)
        yield put({type: FETCH_RESOURCE_ERROR, payload: error})
    }
}

function* fetchDeleteApiKeySaga({payload}){
    console.log(payload)
    try {
        const deleteApiTokenResponse = yield call(deleteApiToken, payload.params.token);
        console.log('Delete: ', deleteApiTokenResponse);
        const data = deleteApiTokenResponse ? deleteApiTokenResponse.data : null
        if(deleteApiTokenResponse && deleteApiTokenResponse.status === 200){
            yield put({type: FETCH_DELETE_API_TOKEN_SUCCESS, payload: data})
            yield put({type: FETCH_RESOURCE_LOADED})
            // console.log(userModelsResponse);
            const userResponse = yield call(getUserData, payload.params.token);
            if(userResponse.status === 200){
                yield put({type: FETCH_GET_USER_DATA_SUCCESS, payload: userResponse.data})
                yield put({type: FETCH_RESOURCE_LOADED})
            }
        } else {
            console.log(deleteApiTokenResponse)
            let renewToken = document.cookie.replace(/(?:(?:^|.*;\s*)refreshToken\s*\=\s*([^;]*).*$)|^.*$/, "$1");

            if(data && data.detail && isValidateToken(data.detail)) {
                let refreshResponse = yield call(refreshToken, renewToken);
                // console.log("Refresh: ", refreshResponse)
                if(refreshResponse.status === 200) {
                    document.cookie = `idToken=${refreshResponse.data.idToken}; max-age=${60*60*3}; path=/`
                    document.cookie = `refreshToken=${refreshResponse.data.refreshToken}; max-age=${60*60*3}; path=/`
                    refreshResponse.data.action = "New Token"
                    yield put({type: FETCH_RENEW_PASSWORD_SUCCESS, payload: refreshResponse.data})
                    
                    const deleteApiTokenResponse2 = yield call(deleteApiToken, refreshResponse.data.idToken);
                    const data2 = deleteApiTokenResponse2.data
                    console.log(deleteApiTokenResponse2);
                    if(deleteApiTokenResponse2.status === 200){
                        yield put({type: FETCH_DELETE_API_TOKEN_SUCCESS, payload: data2})
                        yield put({type: FETCH_RESOURCE_LOADED})
                        // console.log(apiTokenResponse2);
                        const userResponse2 = yield call(getUserData, refreshResponse.data.idToken);
                        if(userResponse2.status === 200){
                            yield put({type: FETCH_GET_USER_DATA_SUCCESS, payload: userResponse2.data})
                            yield put({type: FETCH_RESOURCE_LOADED})
                        }
                    }
                    yield put({type: FETCH_RESOURCE_LOADED})
                } else {
                    yield put({type: FETCH_RESOURCE_ERROR, payload: refreshResponse.data})
                }
            } else yield put({type: FETCH_RESOURCE_ERROR, payload: data});
        }
    } catch(error){
        console.log(error)
        yield put({type: FETCH_RESOURCE_ERROR, payload: error})
    }
}

function* fetchSetDarModeSaga({payload}){
    // console.log(payload)
    try {
        const setDarkModeResponse = yield call(setDarkMode, payload.params.token, payload.params.dark_mode);
        console.log('Dark Mode: ', setDarkModeResponse);
        const data = setDarkModeResponse ? setDarkModeResponse.data : null
        if(setDarkModeResponse && setDarkModeResponse.status === 200){
            yield put({type: FETCH_SET_DARKMODE_SUCCESS, payload: data})
            yield put({type: FETCH_RESOURCE_LOADED})
            // console.log(userModelsResponse);
            const userResponse = yield call(getUserData, payload.params.token);
            if(userResponse.status === 200){
                yield put({type: FETCH_GET_USER_DATA_SUCCESS, payload: userResponse.data})
                yield put({type: FETCH_RESOURCE_LOADED})
            }
        } else {
            let renewToken = document.cookie.replace(/(?:(?:^|.*;\s*)refreshToken\s*\=\s*([^;]*).*$)|^.*$/, "$1");

            if(data && data.detail && isValidateToken(data.detail)) {
                let refreshResponse = yield call(refreshToken, renewToken);
                // console.log("Refresh: ", refreshResponse)
                if(refreshResponse.status === 200) {
                    document.cookie = `idToken=${refreshResponse.data.idToken}; max-age=${60*60*3}; path=/`
                    document.cookie = `refreshToken=${refreshResponse.data.refreshToken}; max-age=${60*60*3}; path=/`
                    refreshResponse.data.action = "New Token"
                    yield put({type: FETCH_RENEW_PASSWORD_SUCCESS, payload: refreshResponse.data})
                    
                    const setDarkModeResponse2 = yield call(setDarkMode, refreshResponse.data.idToken, payload.params.dark_mode);
                    console.log('Dark Mode: ', setDarkModeResponse2);
                    const data = setDarkModeResponse2 ? setDarkModeResponse2.data : null
                    if(setDarkModeResponse2 && setDarkModeResponse2.status === 200){
                        yield put({type: FETCH_SET_DARKMODE_SUCCESS, payload: data})
                        yield put({type: FETCH_RESOURCE_LOADED})
                        // console.log(userModelsResponse);
                        const userResponse2 = yield call(getUserData, refreshResponse.data.idToken);
                        if(userResponse2.status === 200){
                            yield put({type: FETCH_GET_USER_DATA_SUCCESS, payload: userResponse2.data})
                            yield put({type: FETCH_RESOURCE_LOADED})
                        }
                    }
                    yield put({type: FETCH_RESOURCE_LOADED})
                } else {
                    yield put({type: FETCH_RESOURCE_ERROR, payload: refreshResponse.data})
                }
            } else yield put({type: FETCH_RESOURCE_ERROR, payload: data});
        }
    } catch(error){
        console.log(error)
        yield put({type: FETCH_RESOURCE_ERROR, payload: error})
    }
}

function* fetchValidateUserIdSaga({payload}){
    // console.log(payload)
    try {
        const validateUserIdResponse = yield call(getValidationUserId, payload.params.token, payload.params.user_id);
        let data = validateUserIdResponse.data
        console.log('Response: ', validateUserIdResponse)
        if(validateUserIdResponse.status === 200){
            yield put({type: FETCH_GET_VALIDATION_USERID_SUCCESS, payload: validateUserIdResponse.data})
            yield put({type: FETCH_RESOURCE_LOADED})
        } else {
            let renewToken = document.cookie.replace(/(?:(?:^|.*;\s*)refreshToken\s*\=\s*([^;]*).*$)|^.*$/, "$1");

            if(data && data.detail && isValidateToken(data.detail)) {
                const refreshResponse = yield call(refreshToken, renewToken);
                // console.log("Refresh: ", refreshResponse)
                if(refreshResponse && refreshResponse.status === 200) {
                    document.cookie = `idToken=${refreshResponse.data.idToken}; max-age=${60*60*3}; path=/`
                    document.cookie = `refreshToken=${refreshResponse.data.refreshToken}; max-age=${60*60*3}; path=/`
                    refreshResponse.data.action = "New Token"
                    yield put({type: FETCH_RENEW_PASSWORD_SUCCESS, payload: refreshResponse.data})
                    const validateUserIdResponse2 = yield call(getValidationUserId, refreshResponse.data.idToken, payload.params.user_id);
                    if(validateUserIdResponse2.status === 200){
                        yield put({type: FETCH_GET_VALIDATION_USERID_SUCCESS, payload: validateUserIdResponse2.data})
                        yield put({type: FETCH_RESOURCE_LOADED})
                    }
                    yield put({type: FETCH_RESOURCE_LOADED})
                } else {
                    yield put({type: FETCH_RESOURCE_ERROR, payload: refreshResponse.data})
                }
            } else yield put({type: FETCH_RESOURCE_ERROR, payload: data});
        }
    } catch(error){
        console.log('Response: ', error)
        yield put({type: FETCH_RESOURCE_ERROR, payload: error})
    }
}

function* fetchChangeUserIdSaga({payload}){
    // console.log(payload)
    try {
        const changeUserIdResponse = yield call(changeUserId, payload.params.token, payload.params.user_id);
        let data = changeUserIdResponse.data
        console.log('Response: ', changeUserIdResponse)
        if(changeUserIdResponse.status === 200){
            yield put({type: FETCH_CHANGE_USERID_SUCCESS, payload: changeUserIdResponse.data})
            const userResponse = yield call(getUserData, payload.params.token);
            // let data = userResponse.data
            if(userResponse.status === 200){
                yield put({type: FETCH_GET_USER_DATA_SUCCESS, payload: userResponse.data})
                yield put({type: FETCH_RESOURCE_LOADED})
            }
            yield put({type: FETCH_RESOURCE_LOADED})
        } else {
            let renewToken = document.cookie.replace(/(?:(?:^|.*;\s*)refreshToken\s*\=\s*([^;]*).*$)|^.*$/, "$1");

            if(data && data.detail && isValidateToken(data.detail)) {
                const refreshResponse = yield call(refreshToken, renewToken);
                // console.log("Refresh: ", refreshResponse)
                if(refreshResponse && refreshResponse.status === 200) {
                    document.cookie = `idToken=${refreshResponse.data.idToken}; max-age=${60*60*3}; path=/`
                    document.cookie = `refreshToken=${refreshResponse.data.refreshToken}; max-age=${60*60*3}; path=/`
                    refreshResponse.data.action = "New Token"
                    yield put({type: FETCH_RENEW_PASSWORD_SUCCESS, payload: refreshResponse.data})
                    const changeUserIdResponse2 = yield call(changeUserId, refreshResponse.data.idToken, payload.params.user_id);
                    if(changeUserIdResponse2.status === 200){
                        yield put({type: FETCH_CHANGE_USERID_SUCCESS, payload: changeUserIdResponse2.data})
                        const userResponse = yield call(getUserData, payload.params.token);
                        // let data = userResponse.data
                        if(userResponse.status === 200){
                            yield put({type: FETCH_GET_USER_DATA_SUCCESS, payload: userResponse.data})
                            yield put({type: FETCH_RESOURCE_LOADED})
                        }
                        yield put({type: FETCH_RESOURCE_LOADED})
                    }
                    yield put({type: FETCH_RESOURCE_LOADED})
                } else {
                    yield put({type: FETCH_RESOURCE_ERROR, payload: refreshResponse.data})
                }
            } else yield put({type: FETCH_RESOURCE_ERROR, payload: data});
        }
    } catch(error){
        console.log('Response: ', error)
        yield put({type: FETCH_RESOURCE_ERROR, payload: error})
    }
}

function* fetchChangePasswordSaga({payload}){
    console.log(payload)
    try {
        const changePasswordResponse = yield call(postForgotPassword, payload.params.email);
        let data = changePasswordResponse.data
        console.log('Response: ', changePasswordResponse)
        if(changePasswordResponse.status === 200){
            yield put({type: FETCH_CHANGE_PASSWORD_SUCCESS, payload: changePasswordResponse.data})
            yield put({type: FETCH_RESOURCE_LOADED})
        } else {
            let renewToken = document.cookie.replace(/(?:(?:^|.*;\s*)refreshToken\s*\=\s*([^;]*).*$)|^.*$/, "$1");

            if(data && data.detail && isValidateToken(data.detail)) {
                const refreshResponse = yield call(refreshToken, renewToken);
                // console.log("Refresh: ", refreshResponse)
                if(refreshResponse && refreshResponse.status === 200) {
                    document.cookie = `idToken=${refreshResponse.data.idToken}; max-age=${60*60*3}; path=/`
                    document.cookie = `refreshToken=${refreshResponse.data.refreshToken}; max-age=${60*60*3}; path=/`
                    refreshResponse.data.action = "New Token"
                    yield put({type: FETCH_RENEW_PASSWORD_SUCCESS, payload: refreshResponse.data})
                    const changePasswordResponse2 = yield call(postForgotPassword, payload.params.email);
                    console.log('Response: ', changePasswordResponse2)
                    if(changePasswordResponse2.status === 200){
                        yield put({type: FETCH_CHANGE_PASSWORD_SUCCESS, payload: changePasswordResponse2.data})
                        yield put({type: FETCH_RESOURCE_LOADED})
                    }
                    yield put({type: FETCH_RESOURCE_LOADED})
                } else {
                    yield put({type: FETCH_RESOURCE_ERROR, payload: refreshResponse.data})
                }
            } else yield put({type: FETCH_RESOURCE_ERROR, payload: data});
        }
    } catch(error){
        yield put({type: FETCH_RESOURCE_ERROR, payload: error})
    }
}

function* fetchNewPasswordSaga({payload}){
    console.log(payload)
    try {
        const newPasswordResponse = yield call(postNewPassword, payload.params.action_code, payload.params.new_password);
        let data = newPasswordResponse.data
        console.log('Response: ', newPasswordResponse)
        if(newPasswordResponse.status === 200){
            yield put({type: FETCH_NEW_PASSWORD_SUCCESS, payload: newPasswordResponse.data})
            yield put({type: FETCH_RESOURCE_LOADED})
        } else {
            yield put({type: FETCH_RESOURCE_ERROR, payload: data});
        }
    } catch(error){
        yield put({type: FETCH_RESOURCE_ERROR, payload: error})
    }
}

function* watchGetDataModelSagas(){
    yield takeEvery(FETCH_GET_USER_DATA, fetchGetUserDataSaga)
}

function* watchGetUserListSagas(){
    yield takeEvery(FETCH_GET_USER_LIST, fetchGetUserListSaga)
}

function* watchAddUserSagas(){
    yield takeEvery(FETCH_ADD_USER, fetchAddUserSaga)
}

function* watchRemoveUserSagas(){
    yield takeEvery(FETCH_REMOVE_USER, fetchRemoveUserSaga)
}

function* watchModelByUserSagas(){
    yield takeEvery(FETCH_GET_MODELS_BY_USER, fetchGetModelsByUserSaga)
}

function* watchAddModelSagas(){
    yield takeEvery(FETCH_ADD_MODEL, fetchAddModelSaga)
}

function* watchEditModelSagas(){
    yield takeEvery(FETCH_EDIT_MODEL, fetchEditModelSaga)
}

function* watchDeleteModelSagas(){
    yield takeEvery(FETCH_DELETE_MODEL, fetchDeleteModelSaga)
}

function* watchVersionModelSagas(){
    yield takeEvery(FETCH_VERSION_MODEL, fetchVersionOperationSaga)
}

function* watchApiTokenSagas(){
    yield takeEvery(FETCH_GET_NEW_API_TOKEN, fetchGetApiTokenSaga)
}

function* watchDeleteApiKeySagas(){
    yield takeEvery(FETCH_DELETE_API_TOKEN, fetchDeleteApiKeySaga)
}

function* watchDarkModeSagas(){
    yield takeEvery(FETCH_SET_DARKMODE, fetchSetDarModeSaga)
}

function* watchValidateUserIdSagas(){
    yield takeEvery(FETCH_GET_VALIDATION_USERID, fetchValidateUserIdSaga)
}

function* watchChangeUserIdSagas(){
    yield takeEvery(FETCH_CHANGE_USERID, fetchChangeUserIdSaga)
}

function* watchChangePasswordSagas(){
    yield takeEvery(FETCH_CHANGE_PASSWORD, fetchChangePasswordSaga)
}

function* watchNewPasswordSagas(){
    yield takeEvery(FETCH_NEW_PASSWORD, fetchNewPasswordSaga)
}

export default [
    watchGetDataModelSagas, 
    watchGetUserListSagas, 
    watchAddUserSagas, 
    watchRemoveUserSagas, 
    watchModelByUserSagas, 
    watchAddModelSagas, 
    watchEditModelSagas, 
    watchDeleteModelSagas,
    watchVersionModelSagas,
    watchApiTokenSagas, 
    watchDeleteApiKeySagas,
    watchDarkModeSagas,
    watchValidateUserIdSagas,
    watchChangeUserIdSagas,
    watchChangePasswordSagas,
    watchNewPasswordSagas
]

// eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYmYiOjE1ODAxMDEwNTYsImZyZXNoIjpmYWxzZSwiaWRlbnRpdHkiOiJhZG1pbkBhZG1pbi5jb20iLCJpYXQiOjE1ODAxMDEwNTYsInR5cGUiOiJhY2Nlc3MiLCJqdGkiOiIwMzI4MzdkZC1kYTdiLTRjZGMtODdjOS00ZWQ1OTM1NjkzYjIiLCJleHAiOjE1ODI2OTMwNTZ9.veBoRI1VQs4gAGT73Txbl0HKMsRwMA9eSK5q9m_Sak8